import {
  GET_TRANSACTION_RECONCILIATION,
  SET_TRANSACTION_RECONCILIATION,
  SET_TRANSACTION_RECONCILIATION_LOADER,
  SET_TRANSITION_DATE,
  GET_TRANSACTION_CHART,
  SET_TRANSACTION_CHART
} from "./actionTypes";

export const getTransactionReconciliation = params => ({
  type: GET_TRANSACTION_RECONCILIATION,
  payload: params,
});

export const setTransactionReconciliation = data => ({
  type: SET_TRANSACTION_RECONCILIATION,
  payload: data,
});

export const setDateTransitions = data => ({
  type: SET_TRANSITION_DATE,
  payload: data,
});

export const setReconciliationLoader = () => ({
  type: SET_TRANSACTION_RECONCILIATION_LOADER,
})

// Tested
export const getTransactionsChart = (data) => ({
  type: GET_TRANSACTION_CHART,
  payload: data,
})

export const setTransactionsChart = (data) => ({
  type: SET_TRANSACTION_CHART,
  payload: data,
})